<template>
    <v-content>
        <v-row>
            <v-col
                class="mt-0 pt-0"
            >
                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="font-weight-bold">
                                        Recipe Division
                                    </div>
                                </td>
                                <td class='text-right font-weight-bold'>
                                    {{recipeSizeUnits}}
                                </td>
                            </tr>
                            <tr v-for="split in chartData" :key="split.meal">
                                <td><div class="ml-3"> {{split.meal}} </div></td>
                                <td class="text-right"> {{roundToFraction(recipeSize*split.percent/100)}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                class="mt-0 pt-0"
            >
                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="font-weight-bold">
                                        Eat Now Breakdown
                                    </div>
                                </td>
                                <td class='text-right font-weight-bold'>
                                    {{recipeSizeUnits}}
                                </td>
                            </tr>
                            <tr v-for="person in persons" :key="person.name">
                                <td><div class="ml-3"> {{person.name}} </div></td>
                                <td class="text-right"> {{roundToFraction(recipeSize*person.percent/100*chartData[0].percent/100)}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
export default {

    computed: {
        recipeSizeUnits() {
            return this.$store.getters['menu/recipeSizeUnits'];
        },
        recipeSize() {
            return this.$store.getters['menu/recipeSize'];
        },
        chartData() {
            return this.$store.getters['menu/mealSplitChartData'];
        },
        nutrition() {
            return this.$store.getters['menu/nutrition'];
        },
        //persons() {
        //    return this.$store.getters['menu/persons']
        //}
    },
    methods: {
        roundToFraction: function(value) {
            if (this.recipeSizeUnits == "Oz") {
                return Math.round(value)
            } else {
            
            let num = Math.trunc(value)

            let prefix;
                if (num == 0) {
                    prefix = ""
                } else {
                    prefix = num.toString()
                }
            let suffix = ""
                if (Math.trunc((value - Math.trunc(value)) * 10000) >= 9375) {
                    prefix = (num + 1).toString();
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 8125) {
                    suffix = " 7/8"
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 7083) {
                    suffix = " 3/4"
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 6458) {
                    suffix = " 2/3"
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 5625) {
                    suffix = " 5/8"
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 4375) {
                    suffix = " 1/2"
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 3542) {
                    suffix = " 3/8"
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 2917) {
                    suffix = " 1/3"
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 1875) {
                    suffix = " 1/4"
                } else if (Math.trunc((value - Math.trunc(value)) * 10000) >= 625) {
                    suffix = " 1/8"
                }
                return prefix.concat(suffix)
            }
        }
    },
    data: () => ({
        persons: [
            {
            "name": "Dad",
            "calories": 3200,
            "percent": 35,
            },
            {
            "name": "Erich",
            "calories": 3000,
            "percent": 33,
            },
            {
            "name": "Mom",
            "calories": 1600,
            "percent": 17,
            },
            {
            "name": "Lily",
            "calories": 1400,
            "percent": 15,
            },
        ],
    }),

}
</script>
